export default "__VITE_ASSET__Cd4oJ6Q1__"